import React from 'react'

const SubscriptionManagement = () => {
  return (
    <div>
SubscriptionManagement
    </div>
  )
}

export default SubscriptionManagement
